<div
	class="shadow-md p-4 bg-white rounded-lg flex flex-col h-min"
	[class.min-h-44]="layout() === 'tight'"
	[class.min-h-60]="layout() === 'normal'"
	[class.gap-4]="layout() === 'normal'"
	[class.gap-2]="layout() === 'tight'"
	[class.p-4]="layout() === 'normal'"
	[class.p-3]="layout() === 'tight'"
>
	<h3
		class="font-semibold mt-1"
		[class.text-xl]="layout() === 'normal'"
		[class.text-base]="layout() === 'tight'"
	>
		{{ header() | transloco }}
	</h3>

	<div class="flex-auto"></div>

	@for (section of sections(); track $index) {
		@if (section.label) {
			<span class="flex space-between gap-2 items-end">
				<h4
					class="font-semibold flex-auto"
					[class.text-lg]="layout() === 'normal'"
				>
					@if (section.label) {
						@if (
							section.value === null ||
							section.value === undefined
						) {
							{{ section.label | transloco }}
						} @else if (section.valueType === 'dollars') {
							{{
								section.label
									| transloco
										: {
												value:
													(section.value
													| centsToDollars),
										  }
							}}
						} @else if (section.valueType === 'percent') {
							{{
								section.label
									| transloco
										: {
												value:
													(section.value
													| percentToValue),
										  }
							}}
						}
					}
				</h4>

				<p
					class="text-gray-700 font-semibold"
					[class.text-xs]="layout() === 'tight'"
				>
					@if (section.sublabel) {
						{{ section.sublabel | transloco }}
					}
				</p>
			</span>
		}

		@for (option of section.options; track option.key) {
			<mar-breakdown-card-button
				[entity]="entity()"
				(marSelect)="onSelect(option)"
				[active]="active() === option.key"
				[option]="option"
				[analysisId]="analysis().id"
				[calculationId]="calculation().id"
				[class.text-sm]="layout() === 'tight'"
				(marLoaded)="onLoaded()"
			/>
		}

		@if (!$last) {
			<div class="mar-divider mt-2"></div>
		}
	}
</div>
